import { render, staticRenderFns } from "./Expert2RealEstateCommonRequirementEdit.vue?vue&type=template&id=6b05f247&scoped=true&"
import script from "./Expert2RealEstateCommonRequirementEdit.vue?vue&type=script&lang=js&"
export * from "./Expert2RealEstateCommonRequirementEdit.vue?vue&type=script&lang=js&"
import style0 from "./Expert2RealEstateCommonRequirementEdit.vue?vue&type=style&index=0&id=6b05f247&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b05f247",
  null
  
)

export default component.exports